import React from 'react';
import {useFormikContext} from "formik";
import QuotationResponseTable from "../../../../customer/CotizarCustomer/QuotationResponseTable";
import '../../../../../components/customer/CotizarCustomer/QuotationResponseTable.css';

function CotizacionSuccess(props) {
    const {cotizacionResponse, coverageSelectedId, setCoverageSelectedId} = props;
    const {values} = useFormikContext();

    const changeSelectedId = (_id) => {
        if (coverageSelectedId === _id) setCoverageSelectedId(null)
        else {
            values.motovehiculo.nombreModelo =`${values.motovehiculo.detalle_marca} ${values.motovehiculo.detalle_version}`;
            values.motovehiculo.valor = parseInt(cotizacionResponse['vehicleValuation']);
            values.moduloCobertura = cotizacionResponse['plans'][_id]['moduleSancor']
            values.nombreCobertura = cotizacionResponse['plans'][_id]['description']
            values.premium = cotizacionResponse['plans'][_id]['premium']
            values.motovehiculo.equipoDeRastreo = cotizacionResponse['trackingEquipment']
            values.motovehiculo.tipoUso = values.motovehiculo['usoVehiculo'];

            setCoverageSelectedId(_id)
        }
    }

    const detallesCobertura = {
        nombreCobertura: cotizacionResponse['plans'].map(item => item.description),
        premium: cotizacionResponse['plans'].map(item => Math.ceil(item.premium)),
        plans: cotizacionResponse['plans'].map(plan => plan['moduleSancor']),
    }

    return (
       <div style={{marginTop: "16px"}}>
           {cotizacionResponse['plans'].length !== 0
               ? <QuotationResponseTable
                   nombreModelo={`${values.motovehiculo.detalle_marca} ${values.motovehiculo.detalle_version}`}
                   detallesCobertura={detallesCobertura}
                   title={"Detalle de coberturas"}
                   changeSelectedId={changeSelectedId}
                   selectedId={coverageSelectedId}
                   displayFooter
               />
               : <p className="cotable__noCoverages">Sin coberturas disponibles</p>
           }

       </div>
    );
}

export default CotizacionSuccess;
